import React, { useEffect, useState } from "react";
import Sidebar from "../../components/Sidebar";
import Header from "../../components/Header";
import "./OverviewHRAccountManagement.css";
import { gettoastwarning, gettoastsuccess } from '../../Utils/Common';
import { validatehr } from '../../Utils/validate';
import API from '../../Utils/Api';
import loader from '../../assests/loader.gif';

const OverviewHRAccountManagement = () => {
  const [loading, setLoading] = useState(true);
  const [errors, setErrors] = useState({});

  const [inputs, setInputs] = useState({ first_name: '', middel_name: '', last_name: '', cell_phone: '', zoom_account: '', company_email: '', personal_email: '', address: '', city_or_state: '', zipcode: '', country: '', employee_id: '', level: '', department: '', job_title: '', supervisor: '', authorized_pages: '', temp_password: '', new_password: '' });
  const [image, setImage] = useState({ preview: '', raw: '' });

  const [country, setCountry] = useState([]);
  const [level, setLevel] = useState([]);
  const [dept, setDept] = useState([]);


  useEffect(() => {
    document.title = `create-account | bluefaucet`;
    document.getElementById("bodywrap").className = "infr";
    setLoading(false);
    /* Start get country */
    API.get('backoffice_country')
      .then(response => {

        if (response.data.status === 0) {

        } else {
          setCountry(response.data.data);
        }
      }).catch(error => {

      });
    /* End get country */

    /* Start get level */
    API.get('backoffice_level')
      .then(response => {

        if (response.data.status === 0) {

        } else {
          setLevel(response.data.data);
        }
      }).catch(error => {

      });
    /* End get level */

    /* Start get department */
    API.get('backoffice_department')
      .then(response => {

        if (response.data.status === 0) {

        } else {
          setDept(response.data.data);
        }
      }).catch(error => {

      });
    /* End get department */

  }, []);

  /* Start Value set */
  const handleInputChange = (event) => {
    event.persist();
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }));
  }
  /* End Value set */
  /* Start image set */
  const handleChangeImg = (event) => {
    event.preventDefault();
    if (!event.target.files[0].name.match(/\.(jpg|jpeg|png|gif)$/)) {
      gettoastwarning('Please select valid image.', '');
    } else {
      setImage({
        preview: URL.createObjectURL(event.target.files[0]),
        raw: event.target.files[0]
      });
    }
  }
  /* Start image set */
  //Start Login check
  const handleSubmit = (event) => {
    event.preventDefault();
    const validationErrors = validatehr(inputs, image);
    const noErrors = Object.keys(validationErrors).length === 0;
    setErrors({});
    setErrors(validationErrors);
    if (noErrors) {
      setLoading(true);
      const token = localStorage.getItem('token');

      let formData = new FormData();
      formData.append('token', token);
      Object.keys(inputs).forEach((key) => {
        formData.append(key, inputs[key]);
      });
      formData.append('profile', image.raw);
      API.post('backoffice_create_account', formData)
        .then(response => {
          setLoading(false);
          if (response.data.status === 1) {
            gettoastsuccess(response.data.message, '/hr-creation');
          } else {
            gettoastwarning(response.data.message, '');

          }
        }).catch(error => {
          setLoading(false);
          gettoastwarning("Something went wrong. Please try again later.", '');
        });
    }
  }



  return (
    <>
      <div className="container-fluid">
        <div className="row">
          <Sidebar />

          <div className="col-md-9 col-lg-9 col-xl-10 col-xxl-10 ">
            <Header />
            <div className="row">
              <div className="content">
                <div className="row">
                  <div className="col-md-12 col-lg-9 holisti okhas">
                    <h1>Account Management</h1>
                    <div className="accou-card">
                      <div className="row g-2 g-md-3">
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">First name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="First name"
                            name="first_name"
                            onChange={handleInputChange} value={inputs.first_name}
                          />
                          {errors.first_name && (<p className="text-danger text-start mb-0">{errors.first_name}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Middle Name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Middle name"
                            name="middel_name"
                            onChange={handleInputChange} value={inputs.middel_name}
                          />
                          {errors.middel_name && (<p className="text-danger text-start mb-0">{errors.middel_name}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Last name</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Last name"
                            name="last_name"
                            onChange={handleInputChange} value={inputs.last_name}
                          />
                          {errors.last_name && (<p className="text-danger text-start mb-0">{errors.last_name}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label htmlFor="fileUpload" className="form-label">Upload your picture</label>
                          <input
                            type="file"
                            id="fileUpload"
                            className="form-control w-100"
                            accept="image/*"
                            onChange={handleChangeImg}
                          />
                          {errors.profile && (<p className="text-danger text-start mb-0">{errors.profile}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">

                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">

                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Cell phone</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter phone number"
                            name="cell_phone"
                            onChange={handleInputChange} value={inputs.cell_phone}
                          />
                          {errors.cell_phone && (<p className="text-danger text-start mb-0">{errors.cell_phone}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Zoom Account</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Zoom account"
                            name="zoom_account"
                            onChange={handleInputChange} value={inputs.zoom_account}
                          />
                          {errors.zoom_account && (<p className="text-danger text-start mb-0">{errors.zoom_account}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">
                            Company Email address
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Email address"
                            name="company_email"
                            onChange={handleInputChange} value={inputs.company_email}
                          />
                          {errors.company_email && (<p className="text-danger text-start mb-0">{errors.company_email}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">
                            Personal Email address
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Email address"
                            name="personal_email"
                            onChange={handleInputChange} value={inputs.personal_email}
                          />
                          {errors.personal_email && (<p className="text-danger text-start mb-0">{errors.personal_email}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">
                            Mailing Address - No., Street
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Address"
                            name="address"
                            onChange={handleInputChange} value={inputs.address}
                          />
                          {errors.address && (<p className="text-danger text-start mb-0">{errors.address}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">City, State</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="City, State"
                            name="city_or_state"
                            onChange={handleInputChange} value={inputs.city_or_state}
                          />
                          {errors.city_or_state && (<p className="text-danger text-start mb-0">{errors.city_or_state}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Zip Code</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Zip code"
                            name="zipcode"
                            onChange={handleInputChange} value={inputs.zipcode}
                          />
                          {errors.zipcode && (<p className="text-danger text-start mb-0">{errors.zipcode}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Country</label>
                          <select className="form-select" name="country" onChange={handleInputChange} value={inputs.country}>
                            <option value="">Select Country</option>
                            {country && country.map((val, index) => {
                              return (
                                <option value={val.id} key={index}>{val.name}</option>
                              )
                            })}
                          </select>
                          {errors.country && (<p className="text-danger text-start mb-0">{errors.country}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Employee ID#</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="ID Number"
                            name="employee_id" onChange={handleInputChange} value={inputs.employee_id}
                          />
                          {errors.employee_id && (<p className="text-danger text-start mb-0">{errors.employee_id}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Level</label>
                          <select className="form-select" name="level" onChange={handleInputChange} value={inputs.level}>
                            <option value="">Level</option>
                            {level && level.map((val, index) => {
                              return (
                                <option value={val.id} key={index}>{val.name}</option>
                              )
                            })}
                          </select>
                          {errors.level && (<p className="text-danger text-start mb-0">{errors.level}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Dept</label>
                          <select className="form-select" name="department" onChange={handleInputChange} value={inputs.department}>
                            <option value="">Dept</option>
                            {dept && dept.map((val, index) => {
                              return (
                                <option value={val.id} key={index}>{val.name}</option>
                              )
                            })}
                          </select>
                          {errors.department && (<p className="text-danger text-start mb-0">{errors.department}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-4">
                          <label className="form-label">Job Title</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Job title"
                            name="job_title" onChange={handleInputChange} value={inputs.job_title}
                          />
                          {errors.job_title && (<p className="text-danger text-start mb-0">{errors.job_title}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                          <label className="form-label">Supervisor</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Supervisor"
                            name="supervisor" onChange={handleInputChange} value={inputs.supervisor}
                          />
                          {errors.supervisor && (<p className="text-danger text-start mb-0">{errors.supervisor}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                          <label className="form-label">Authorized Pages</label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Authorized Pages"
                            name="authorized_pages" onChange={handleInputChange} value={inputs.authorized_pages}
                          />
                          {errors.authorized_pages && (<p className="text-danger text-start mb-0">{errors.authorized_pages}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                          <label className="form-label">Temp Password</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="Temp Password"
                            name="temp_password" onChange={handleInputChange} value={inputs.temp_password}
                          />
                          {errors.temp_password && (<p className="text-danger text-start mb-0">{errors.temp_password}</p>)}
                        </div>
                        <div className="col-12 col-sm-6 col-md-6 col-lg-6">
                          <label className="form-label">New Password</label>
                          <input
                            type="password"
                            className="form-control"
                            placeholder="New Password"
                            name="new_password" onChange={handleInputChange} value={inputs.new_password}
                          />
                          {errors.new_password && (<p className="text-danger text-start mb-0">{errors.new_password}</p>)}
                        </div>
                        <div className="col-12">
                          <div className="mt-3">
                            <button type="button" className="submit-btn" onClick={handleSubmit}>Create an account</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {loading && (
        <div className="loadingClass">
          <img src={loader} alt="loader" />
        </div>
      )}
    </>
  );
};

export default OverviewHRAccountManagement;
